// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__axmWt","footer":"ModalCreateQualiphyProcedure_footer__39rzD","additionData":"ModalCreateQualiphyProcedure_additionData__3-v2S"};